import React, { useEffect, useState } from "react";
import { FaCheck, FaClock, FaEdit, FaTruck } from "react-icons/fa";
import { FaBoxArchive, FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Card, Col, Container, Form, Row, Spinner, Table } from "react-bootstrap";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudySiteShipment from "./UpdateStudySiteShipment";
import AddNewStudySiteShipment from "./AddNewStudySiteShipment";
import DeletedStudySiteShipment from "./DeletedStudySiteShipment";
import SiteShipmentActivities from "./SiteShipmentActivities";
import { studySiteManagementServices } from "../../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { eiwrsShipmentManagementServices } from "../../../../APIServices/EIWRS/ShipmentManagement/eiwrsShipmentManagementServices";
import Moment from "react-moment";
import ReceivedAtSiteShipment from "./ReceivedAtSiteShipment";
import { eiwrsTemperatureMetadataServices } from "../../../../APIServices/EIWRS/ShipmentManagement/eiwrsTemperatureMetadataServices";
import ViewSiteShipment from "./ViewSiteShipment";
import { eiwrsCorierManagementServices } from "../../../../APIServices/EIWRS/ShipmentManagement/eiwrsCorierManagementServices";

const StudySiteShipmentDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle3, setToggle3, toggle4, setToggle4 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [shipmentData, setShipmentData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [shipmentList, setShipmentList] = useState([]);
  const [shipmentCount, setShipmentCount] = useState(0);
  const [shipmentPendingCount, setShipmentPendingCount] = useState(0);
  const [shipmentInTransitCount, setShipmentInTransitCount] = useState(0);
  const [shipmentReceivedCount, setShipmentReceivedCount] = useState(0);
  const [deletedStudySiteShipment, setDeletedStudyShipment] = useState([]);
  const [deletedStudySiteShipmentCount, setDeletedStudyShipmentCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [actionLoader, setActionLoader] = useState("");
  const [activeTab, setActiveTab] = useState("activities");
  const [shipmentId, setShipmentId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [shipmentActivity, setShipmentActivity] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [corierList, setCorierList] = useState([]);
  const [temperatureList, setTemperatureList] = useState([]);
  const [shipmentActivityCount, setShipmentActivityCount] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, LoginCat, StudyMode)
    setSiteList(data?.data || [])
  }

  const getStudyCorierRowData = async () => {
    let data = await eiwrsCorierManagementServices.getStudyCorierRowData("active", studyId)
    setCorierList(data?.data || [])
  }

  const getEIWRSTemperatureMetadataData = async () => {
    let data = await eiwrsTemperatureMetadataServices.getEIWRSTemperatureMetadataData("active", studyId)
    setTemperatureList(data?.data || [])
  }

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(shipmentCount / itemsPerPage);

  const getStudySiteShipmentData = async (e) => {
    setLoading(true);
    let data = await eiwrsShipmentManagementServices.getStudySiteShipmentData(
      studyId,
      "active",
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setShipmentList(data?.data || []);
    setShipmentCount(data?.count || 0);
    setShipmentPendingCount(data?.countPending || 0);
    setShipmentInTransitCount(data?.countInTransit || 0);
    setShipmentReceivedCount(data?.countReceived || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudySiteShipment = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsShipmentManagementServices.getStudySiteShipmentData(
      studyId,
      "deleted",
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyShipment(data?.data || []);
    setDeletedStudyShipmentCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studySiteShipment",
      studyId,
      shipmentData?.shipmentId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setShipmentActivity(data?.data || []);
    setShipmentActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [shipmentData]);

  useEffect(() => {
    getStudySiteBasedonAccess();
    getStudyCorierRowData();
    getEIWRSTemperatureMetadataData();
  }, []);

  useEffect(() => {
    getStudySiteShipmentData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreStudySiteShipment = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Site Shipment!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        userData.mode = StudyMode;
        let data =
          await eiwrsShipmentManagementServices.softDeleteRestoreStudySiteShipment(
            userData
          );
        if (data?.statusCode === 200) {
          getStudySiteShipmentData();
          setShipmentId("");
          getDeletedStudySiteShipment();
          if (type === "restore") {
            getDeletedStudySiteShipment(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  const approvedDispatchedSiteShipment = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Approve and Dispatch Shipment!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Approve and Dispatch it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setActionLoader(id)
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.mode = StudyMode;
        let data =
          await eiwrsShipmentManagementServices.approvedDispatchedSiteShipment(
            userData
          );
        if (data?.statusCode === 200) {
          getStudySiteShipmentData();
        }
        setActionLoader("")
      }
    });
  };

  const overviewCards = [
    {
      title: "Total Shipment",
      value: shipmentCount,
      subtitle: "Total shipments recorded across the study",
      icon: <FaBoxArchive className="bg-white text-primary shadow-sm" />,
    },
    {
      title: "Pending Shipment",
      value: shipmentPendingCount,
      subtitle: "Shipments awaiting dispatch or processing",
      icon: <FaClock className="bg-white text-secondary shadow-sm" />,
    },
    {
      title: "In Transit Shipment",
      value: shipmentInTransitCount,
      subtitle: "Shipments currently in transit to destination",
      icon: <FaTruck className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Received Shipment",
      value: shipmentReceivedCount,
      subtitle: "Shipments successfully received at destination",
      icon: <FaCheck className="bg-white text-success shadow-sm" />,
    }
  ];

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {(StudyMode === "DBP Mode" || eiwrsPermission?.liveKitShipmentManagement || eiwrsPermission?.qcKitShipmentManagement) &&
            <>
              <i
                title={isFormOpen ? "Close Form" : "Add New"}
                onClick={() => {
                  setIsFormOpen(!isFormOpen);
                  setShipmentId("");
                }}
                className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
                  }`}
              />
              <div className="vr"></div>
            </>
          }
          {shipmentCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        {(StudyMode === "DBP Mode" || eiwrsPermission?.liveKitShipmentManagement || eiwrsPermission?.qcKitShipmentManagement) &&
          <div className="hstack gap-2">
            {StudyMode === "DBP Mode" &&
              deletedStudySiteShipmentCount > 0 &&
              <button
                onClick={() => {
                  setToggle1();
                  getDeletedStudySiteShipment(
                    pageNumberDeleted,
                    itemsPerPageDeleted
                  );
                }}
                className={`updateProfile`}
              >
                Deleted History
              </button>
            }
          </div>
        }
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={shipmentId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudySiteShipment corierList={corierList} siteList={siteList} getStudySiteShipmentData={getStudySiteShipmentData} />
          )}
          <>
            <Container fluid className="mb-2">
              <Row className="g-2">
                {overviewCards?.map((item, index) => (
                  <Col xl={3} lg={4} md={6} sm={12} key={index} className="pt-2">
                    <Card className="app-card bg-light border h-100">
                      <Card.Body>
                        <div className="d-flex gap-3">
                          <div className="study_icopn">
                            {item.icon}
                          </div>
                          <div>
                            <Card.Title style={{ fontSize: 16 }}>{item.title}</Card.Title>
                            <Card.Text className="m-0">{item.value || "0"}</Card.Text>
                            <Card.Text style={{ fontSize: 11 }}>{item.subtitle}</Card.Text>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Container>
            {loading ? (
              <PageLoader />
            ) : shipmentCount === 0 ? (
              <NoDataFoundTable MSG={"Study Site Shipment not found!"} />
            ) : shipmentList?.length === 0 ? (
              <NoDataFoundTable MSG={"Search Study Site Shipment not found!"} />
            ) : (
              <>
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>
                        Shipment No.
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>
                        Shipment Type
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 3)}>
                        Site
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>
                        Depot
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 5)}>
                        Kits
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 6)}>
                        Corier
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 7)}>
                        Dispatched DT
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 8)}>
                        Received DT
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 9)}>
                        Status
                      </th>
                      {(StudyMode === "DBP Mode" || eiwrsPermission?.liveKitShipmentManagement || eiwrsPermission?.qcKitShipmentManagement) &&
                        <>
                          <th
                            onMouseDown={(e) => onMouseDown(e, 10)}
                            style={{ width: 100 }}
                          >
                            Action
                          </th>
                          <th
                            onMouseDown={(e) => onMouseDown(e, 11)}
                            style={{ width: 45 }}
                            className="text-center"
                          >
                            Edit
                          </th>
                          <th
                            onMouseDown={(e) => onMouseDown(e, 12)}
                            style={{ width: 55 }}
                            className="text-center"
                          >
                            Delete
                          </th>
                        </>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {shipmentList?.map((shipmentData, index) => (
                      <tr
                        key={index}
                        title="View Details"
                        className={`${shipmentData?.type !== "predefine" && "CP"} ${shipmentId === shipmentData?._id ? "highlighted" : ""
                          }`}
                        onClick={() => setIsFormOpen(false)}
                      >
                        <td
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                          className="text-center"
                        >
                          {index + 1 + startIndex}.
                        </td>
                        <td
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                        >
                          {shipmentData?.shipmentNumber}
                        </td>
                        <td
                          className="text-capitalize"
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                        >
                          {shipmentData?.shipmentType} Shipment
                        </td>
                        <td
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                        >
                          {shipmentData?.siteName}
                        </td>
                        <td
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                        >
                          {shipmentData?.depot}
                        </td>
                        <td
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                        >
                          {shipmentData?.totalKit?.length || 0}
                        </td>
                        <td
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                        >
                          {shipmentData?.corier || "_"}
                        </td>
                        <td
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                        >
                          {shipmentData.dispatchedDT ?
                            <Moment format="DD MMM YYYY | HH:mm" withTitle>
                              {shipmentData.dispatchedDT}
                            </Moment>
                            : "_"}
                        </td>
                        <td
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                        >
                          {shipmentData.receivedDT ?
                            <Moment format="DD MMM YYYY | HH:mm" withTitle>
                              {shipmentData.receivedDT}
                            </Moment>
                            : "_"}
                        </td>
                        <td
                          className={`fw-bold text-capitalize ${shipmentData?.status === "inTransit" ? "text-warning" : shipmentData?.status === "received" ? "text-success" : "text-secondary"}`}
                          onClick={() => {
                            setShipmentData(shipmentData);
                            setShipmentId(shipmentData?._id);
                          }}
                        >
                          {shipmentData?.status === "inTransit" ? "In Transit" : shipmentData?.status}
                        </td>
                        {(StudyMode === "DBP Mode" || eiwrsPermission?.liveKitShipmentManagement || eiwrsPermission?.qcKitShipmentManagement) &&
                          <>
                            <td
                              style={{ pointerEvents: "auto" }}
                            >
                              {shipmentData?.status === "pending" ?
                                <button
                                  disabled={actionLoader}
                                  onClick={() => approvedDispatchedSiteShipment(shipmentData?._id)}
                                  className={`updateProfile`}
                                  style={{ padding: "1px 10px" }}
                                >

                                  {actionLoader ? (
                                    <div className="hstack gap-2">
                                      <Spinner size="sm" /> Approving and Dispatching...
                                    </div>
                                  ) : (
                                    "Approve and Dispatch"
                                  )}
                                </button>
                                : shipmentData?.status === "inTransit" ?
                                  <button
                                    onClick={(e) => {
                                      setShipmentData(shipmentData);
                                      setToggle3();
                                      e.stopPropagation();
                                    }}
                                    className={`updateProfile`}
                                    style={{ padding: "1px 10px" }}
                                  >
                                    Receive at Site
                                  </button>
                                  :
                                  <button
                                    onClick={(e) => {
                                      setShipmentData(shipmentData);
                                      setToggle4();
                                      e.stopPropagation();
                                    }}
                                    className={`updateProfile`}
                                    style={{ padding: "1px 10px" }}
                                  >
                                    View Details
                                  </button>
                              }
                            </td>
                            <td
                              className="text-center CP"
                              title={`Update ${shipmentData?.shipmentNumber}`}
                              onClick={(e) => {
                                if (shipmentData?.status !== "received") {
                                  setShipmentData(shipmentData);
                                  setToggle();
                                  e.stopPropagation();
                                }
                              }}
                              style={{ pointerEvents: "auto" }}
                            >
                              <FaEdit className={shipmentData?.status === "received" ? "text-muted" : "text-primary"} />
                            </td>
                            <td
                              className="text-center CP"
                              title={`Delete ${shipmentData?.shipmentNumber}`}
                              onClick={(e) => {
                                if (shipmentData?.status !== "received") {
                                  softDeleteRestoreStudySiteShipment(
                                    shipmentData?._id,
                                    "delete"
                                  );
                                }
                              }}
                            >
                              <FaTrash className={shipmentData?.status === "received" ? "text-muted" : "text-danger"} />
                            </td>
                          </>
                        }
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={shipmentCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </>
        </SplitPane>
        {shipmentId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setShipmentId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <SiteShipmentActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                shipmentActivity={shipmentActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                shipmentData={shipmentData}
                shipmentActivityCount={shipmentActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateStudySiteShipment
        Show={!toggle}
        Hide={setToggle}
        shipmentData={shipmentData}
        siteList={siteList}
        corierList={corierList}
        setShipmentId={setShipmentId}
        getStudySiteShipmentData={getStudySiteShipmentData}
        Title={"Update Study Site Shipment"}
      />
      <ViewSiteShipment
        Show={!toggle4}
        Hide={setToggle4}
        shipmentData={shipmentData}
        Title={"View Site Shipment"}
      />
      <ReceivedAtSiteShipment
        Show={!toggle3}
        Hide={setToggle3}
        shipmentData={shipmentData}
        siteList={siteList}
        temperatureList={temperatureList}
        setShipmentId={setShipmentId}
        getStudySiteShipmentData={getStudySiteShipmentData}
        Title={"Receive At Site Shipment"}
      />
      <DeletedStudySiteShipment
        Show={!toggle1}
        Hide={setToggle1}
        setShipmentId={setShipmentId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudySiteShipment={deletedStudySiteShipment}
        getDeletedStudySiteShipment={getDeletedStudySiteShipment}
        deletedStudySiteShipmentCount={deletedStudySiteShipmentCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudySiteShipment={softDeleteRestoreStudySiteShipment}
        Title={"Deleted Study Site Shipment History"}
      />
    </>
  );
};

export default StudySiteShipmentDataList;
